import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProfile } from '../../../Redux/userSlice';

const InfluencerBillingForm = ({ formData, setFormData, errors, setErrors }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.data);

  useEffect(() => {
    if (!user) {
      dispatch(getUserProfile());
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (!user) return;
    setFormData((prev) => ({
      ...prev,
      email: prev.email || user.email || '',
      name: prev.name || user.name || user.username || '',
      mobile: prev.mobile || (user.mobile || '').replace(/\D/g, '').slice(-10),
    }));
  }, [user, setFormData]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-700">Billing & contact</h3>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Name</label>
        <input
          type="text"
          value={formData.name || ''}
          onChange={handleChange('name')}
          placeholder="Full name"
          className={`w-full px-3 py-2 border rounded-lg text-sm ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
        />
        {errors.name && <p className="text-xs text-red-500 mt-1">{errors.name}</p>}
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Email</label>
        <input
          type="email"
          value={formData.email || ''}
          onChange={handleChange('email')}
          placeholder="you@example.com"
          className={`w-full px-3 py-2 border rounded-lg text-sm ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
        />
        {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Mobile number</label>
        <input
          type="tel"
          value={formData.mobile || ''}
          onChange={handleChange('mobile')}
          placeholder="10-digit mobile number"
          maxLength={10}
          className={`w-full px-3 py-2 border rounded-lg text-sm ${errors.mobile ? 'border-red-500' : 'border-gray-300'}`}
        />
        {errors.mobile && <p className="text-xs text-red-500 mt-1">{errors.mobile}</p>}
      </div>

      <p className="text-xs text-gray-500">
        Your subscription receipt and renewal reminders will be sent to this email.
      </p>
    </div>
  );
};

export default InfluencerBillingForm;
